// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue2(props) {
    return (
        <svg
            id="_x32_"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
            style={{
                enableBackground: 'new 0 0 250 250',
            }}
            xmlSpace="preserve"
            {...props}
        >
            <style type="text/css">
                {
                    "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.002;}\n\t.st11{display:none;}\n\t.st12{display:inline;}\n\t.st13{font-size:4.995px;}\n\t.st14{fill:none;stroke:#B3B3B3;stroke-miterlimit:3.92;}\n\t.st15{fill:none;stroke:#B7B7B7;}\n"
                }
            </style>
            <g id="BAL_00000036227099413093292910000001870353719391862932_">
                <g id="BAL">
                    <g id="compass">
                        <polygon
                            className="st0"
                            points="231.9,207 225.6,200.3 222.6,192.9 228.3,198.5  "
                        />
                        <path
                            className="st1"
                            d="M235.7,212.4c-7.1,4.8-16.7,2.9-21.5-4.2c-4.8-7.1-2.9-16.7,4.2-21.5c7.1-4.8,16.7-2.9,21.5,4.2 C244.7,198,242.8,207.6,235.7,212.4z M219.1,187.7c-6.5,4.4-8.2,13.2-3.8,19.7s13.2,8.2,19.7,3.8s8.2-13.2,3.8-19.7 C234.4,185.1,225.6,183.4,219.1,187.7z"
                        />
                        <path
                            className="st0"
                            d="M227.6,196.6c1.6,0.3,2.7,1.9,2.3,3.5c-0.3,1.6-1.9,2.7-3.5,2.3c-1.6-0.3-2.7-1.9-2.3-3.5 C224.4,197.3,226,196.3,227.6,196.6z"
                        />
                        <g>
                            <path
                                className="st0"
                                d="M220.8,192.5l-1.7-2.6l0.4-0.3l2.4,1l0,0l-1.2-1.8l0.4-0.3l1.7,2.6l-0.4,0.3l-2.4-1l0,0l1.2,1.8 L220.8,192.5z"
                            />
                        </g>
                        <path
                            className="st2"
                            d="M227.3,197.9c0.9,0.2,1.5,1,1.3,1.9s-1,1.5-1.9,1.3s-1.5-1-1.3-1.9S226.4,197.7,227.3,197.9z"
                        />
                    </g>
                    <g id="distances">
                        <text
                            id="right"
                            transform="matrix(1 0 0 1 223.1528 114.3819)"
                            className="st3 st4 st5"
                        >
                            318
                        </text>
                        <text
                            id="right-center_1_"
                            transform="matrix(1 0 0 1 186.1216 58.2989)"
                            className="st3 st4 st5"
                        >
                            373
                        </text>
                        <text
                            id="center_1_"
                            transform="matrix(1 0 0 1 108.7055 32.3105)"
                            className="st3 st4 st5"
                        >
                            410
                        </text>
                        <text
                            id="left-center_1_"
                            transform="matrix(1 0 0 1 47.4623 48.929)"
                            className="st3 st4 st5"
                        >
                            398
                        </text>
                        <text
                            id="left-center_00000176764511194708690110000014035538042753436324_"
                            transform="matrix(1 0 0 1 78.7962 42.7418)"
                            className="st3 st4 st5"
                        >
                            376
                        </text>
                        <text
                            id="left"
                            transform="matrix(1 0 0 1 17.0084 71.3915)"
                            className="st3 st4 st5"
                        >
                            384
                        </text>
                    </g>
                    <g id="field_1_">
                        <path
                            id="warning_track_00000088099211283742417210000004089846493910042815_"
                            className="st6"
                            d="M26.7,107.7c0,0,20,30.6,40.3,58.2 l2.2-0.9c12.4,16.8,24.5,33.7,31.5,43.6c18.8,26.5,32.2,18,46,3.1c10.7-11.4,46.8-62.9,64.4-88.6c1.7-2.5,9.6-0.1,10.9-2 c3.1-4.6-3.3-11.5-3.3-11.5l-1.4-1.9l-1.3-2l-1.3-2l-1.4-2l-1.3-2l-1.4-2l-1.4-2l-1.4-2.1l-1.5-2.1l-1.4-2.2l-1.5-2.1l-1.5-2.2 l-1.5-2.2l-1.5-2.2l-1.6-2.3l-1.6-2.3l-1.6-2.4l-1.6-2.4l-1.7-2.5l-1.7-2.5l-1.7-2.6l-1.7-2.6l-1.8-2.7l-1.9-2.8l-1.9-2.7 l-2.5-1.5l-2.7-0.7l-2.7-0.7l-2.7-0.7l-2.7-0.7l-2.7-0.7l-2.7-0.7l-2.7-0.7l-2.7-0.7l-2.7-0.7l-2.7-0.7l-2.7-0.7l-2.7-0.7 l-2.7-0.7l-2.8-0.7l-2.8-0.7l-2.8-0.8l-2.8-0.7l-2.9-0.8l-2.9-0.8l-2.9-0.8l-3-0.8l-3-0.8l-3-0.8l-3,0.2l-2.8,1.9l-2.7,1.8 l-2.7,1.8L99.8,42L97,43.1l-2.6,1.7l-2.5,1.7l-2.5,1.7L87,49.9l-2.4,1.7l-2.1,1.2l-0.7-1l-5.2-7.5l-2.7,1L71.5,47L69,48.7 l-2.5,1.7L64.2,52l-2.4,1.6l-2.4,1.6L57,56.9l-2.3,1.6l-2.3,1.6L50,61.6l-2.3,1.6l-2.3,1.6l-2.3,1.5l-2.3,1.6l-2.3,1.5L36.2,71 l-2.3,1.6l-2.3,1.5l-2.3,1.6L27,77.3L25.5,80l-1.2,2.9l-1.2,2.9l0.1,4.2l1.9,5.9l1.7,5.5l0.3,3.8L26.7,107.7z"
                        />
                        <path
                            id="grass"
                            className="st3"
                            d="M175.2,58.2L113.3,41L83.7,61l-12.9-4.8l-38.3,26L30,87.9l5.1,16.8l-1.3,3.3 c0,0,47.1,68,70.5,97.3c6.2,8.8,12.9,15.5,20.3,15.5c7.9,0,15.1-8.3,18.6-13.4c2.6-3.7,11.8-11.9,21.7-26.5 c19.7-28.9,46.1-70.4,46.1-70.4L175.2,58.2z"
                        />
                        <path
                            id="infield_sand"
                            className="st6"
                            d="M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
                        />
                    </g>
                    <g id="persistent_2_">
                        <g id="mound_2_">
                            <path
                                id="pitching-mound_2_"
                                className="st6"
                                d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
                            />
                            <rect
                                id="pitching-rubber_2_"
                                x={123.2}
                                y={176.6}
                                className="st7"
                                width={4}
                                height={1.6}
                            />
                        </g>
                        <g id="lines_2_">
                            <line
                                id="left-foul-line_2_"
                                className="st8"
                                x1={125.2}
                                y1={203.2}
                                x2={27}
                                y2={105.1}
                            />
                            <line
                                id="right-foul-line_3_"
                                className="st8"
                                x1={125.2}
                                y1={203.2}
                                x2={218.7}
                                y2={109.6}
                            />
                        </g>
                        <g id="bases_2_">
                            <rect
                                id="third-base_2_"
                                x={99.2}
                                y={175.1}
                                transform="matrix(0.7073 -0.7069 0.7069 0.7073 -95.3661 122.8889)"
                                className="st9"
                                width={3}
                                height={3}
                            />
                            <rect
                                id="first-base_2_"
                                x={148.1}
                                y={175.2}
                                transform="matrix(0.7073 -0.7069 0.7069 0.7073 -81.1129 157.4789)"
                                className="st9"
                                width={3}
                                height={3}
                            />
                            <rect
                                id="second-base_2_"
                                x={123.7}
                                y={148.6}
                                transform="matrix(0.707 -0.7073 0.7073 0.707 -69.4747 132.5383)"
                                className="st10"
                                width={3}
                                height={3}
                            />
                            <polygon
                                id="home_2_"
                                className="st7"
                                points="126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
                            />
                        </g>
                    </g>
                </g>
                <g id="grid" className="st11">
                    <g className="st12">
                        <g id="numbers">
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 90.9866 184.0761)"
                                className="st4 st13"
                            >
                                90
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 56.4654 153.8222)"
                                className="st4 st13"
                            >
                                200
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 71.0452 168.4018)"
                                className="st4 st13"
                            >
                                150
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 80.378 177.7343)"
                                className="st4 st13"
                            >
                                120
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 41.6028 138.9599)"
                                className="st4 st13"
                            >
                                250
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 27.4712 123.956)"
                                className="st4 st13"
                            >
                                300
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 12.6905 109.1753)"
                                className="st4 st13"
                            >
                                350
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 75.9258)"
                                className="st4 st13"
                            >
                                400
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 49.4311)"
                                className="st4 st13"
                            >
                                450
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 24.6201)"
                                className="st4 st13"
                            >
                                500
                            </text>
                        </g>
                        <g id="surface29_2_">
                            <path className="st14" d="M125.5,203.8l-148-148" />
                            <path className="st14" d="M124.8,203.8l148-148" />
                            <path className="st15" d="M125.1,203.5L45.4,10.9" />
                            <path className="st15" d="M125.1,203.5V-4.9" />
                            <path
                                className="st15"
                                d="M125.1,203.5l79.8-192.6"
                            />
                        </g>
                        <path
                            id="_x31_00-line"
                            className="st14"
                            d="M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
                        />
                        <path
                            id="_x32_00-line_2_"
                            className="st14"
                            d="M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5c23,0,43.8,9.3,58.8,24.4"
                        />
                        <path
                            id="_x39_0-line_2_"
                            className="st14"
                            d="M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1c10.4,0,19.7,4.2,26.5,11"
                        />
                        <path
                            id="_x31_20-line"
                            className="st14"
                            d="M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4c17.2,0,32.8,7,44.1,18.3"
                        />
                        <path
                            id="_x32_50-line"
                            className="st14"
                            d="M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6c28.7,0,54.7,11.6,73.6,30.5"
                        />
                        <path
                            id="_x33_00-line"
                            className="st14"
                            d="M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
                        />
                        <path
                            id="_x33_50-line"
                            className="st14"
                            d="M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1c40.2,0,76.6,16.3,103,42.7"
                        />
                        <path
                            id="_x34_50-line"
                            className="st14"
                            d="M-7.4,70.9c33.9-34,80.8-55,132.6-55c51.7,0,98.6,21,132.5,54.9"
                        />
                        <path
                            id="_x34_00-line_1_"
                            className="st14"
                            d="M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9c46,0,87.6,18.6,117.7,48.8"
                        />
                        <path
                            id="_x35_00-line"
                            className="st14"
                            d="M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9c57.5,0,109.5,23.3,147.2,61"
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default Venue2
